module.exports = function() {
  return new Worker(__webpack_public_path__ + "1c177ef91705ef1b17b0.worker.js");
};